export const tikiContext = 'tiki';
